<nav class="slider-label level is-mobile">
	<div class="level-left">
		<div class="level-item">{{ left }}</div>
	</div>

	<div class="level-right">
		<div class="level-item">{{ disableAddPlus ? right : right + '+' }}</div>
	</div>
</nav>